var _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg064Flag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#ffe6e2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.167 8c-.194 0-.367.107-.447.28-.087.167-.067.373.047.527l1.94 2.527-1.94 2.527c-.113.153-.133.36-.047.527.08.173.253.28.447.28h6.833v-6.168c0-.173.033-.347.087-.5z",
    fill: "#fd907e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc573b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.667,
    cy: 17.667,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.333,
    cy: 19.333,
    r: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.167 21.333h-1.667c-1.011 0-1.833.822-1.833 1.833v.334c0 .276.224.5.5.5h4.333c.276 0 .5-.224.5-.5v-.333c0-1.011-.822-1.834-1.833-1.834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 20.667h-3.667c-1.011 0-1.833.822-1.833 1.833v1c0 .276.224.5.5.5h6.333c.276 0 .5-.224.5-.5v-1c0-1.011-.822-1.833-1.833-1.833z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5 24c-.276 0-.5-.224-.5-.5v-15c0-.276.224-.5.5-.5s.5.224.5.5v15c0 .276-.224.5-.5.5z",
    fill: "#fd907e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg064Flag);
export default __webpack_public_path__ + "static/media/064-flag.14f56464aa33e269dc876a9bf990baf6.svg";
export { ForwardRef as ReactComponent };